<template>
  <div class="image_box" v-loading.fullscreen.lock="showLoading">
    <div class="box_operation">
      <div class="input_box">
        <el-cascader
            @change="selectChange"
            v-model="categoryId"
            :options="categoryList"
            :props="{ checkStrictly: true,value:'id',label:'categoryName',children:'childList'}"
            clearable>
        </el-cascader>

        <!--        <el-select v-model="categoryId" placeholder="分类" clearable :style="{width: '100%'}" size="big">-->
        <!--          <el-option v-for="(item, index) in categoryList" :key="index" :label="item.categoryName"-->
        <!--                     :value="item.id" :disabled="item.disabled" >-->
        <!--          </el-option>-->
        <!--        </el-select>-->
      </div>

      <!--操作列表-->
      <div class="input_box">
        <el-select v-model="pageCount" placeholder="请选择" @change="reset">
          <el-option
              v-for="item in pageNumList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
          </el-option>
        </el-select>
      </div>
      <!--            操作列表-->
      <div class="input_box">
        <el-input placeholder="请输入图片名称" v-model="searchName" class="input-with-select"></el-input>
      </div>
      <div class="input_box">
        <el-date-picker
            v-model="startTime"
            type="date"
            placeholder="开始日期">
        </el-date-picker>
      </div>
      <div class="input_box">
        <el-date-picker
            v-model="endTime"
            type="date"
            placeholder="结束日期">
        </el-date-picker>
      </div>
    </div>

    <!--    <el-dialog :title="dialogTitle"-->
    <!--               @close="closeDialog"-->
    <!--               top="5vh"-->
    <!--               :visible.sync="showDialogtoo"-->
    <!--               :close-on-click-modal="false"-->
    <!--               width="1200px"-->
    <!--               @opened="dialogOpen"-->
    <!--               :destroy-on-close="true"-->
    <!--               :fullscreen="false">-->
    <!--      <ImageBox @postFrom="postFrom"/>-->
    <!--    </el-dialog>-->
    <div class="box_operation">
      <!--      <div class="btn_box">-->
      <!--        <el-button  type="primary" @click="open">点击查询</el-button>-->
      <!--      </div>-->
      <div class="btn_box">
        <el-button type="warning" @click="search">搜索</el-button>
      </div>
      <div class="btn_box">
        <el-button type="primary" @click="addImage">添加</el-button>
      </div>
      <div class="btn_box">
        <el-button type="success" @click="reset">重置</el-button>
      </div>
      <div class="btn_box">
        <el-button type="danger" @click="getImages">刷新</el-button>
      </div>
      <div class="btn_box">
        <el-button type="info" @click="delImages">删除{{ delImageIds.length }}</el-button>
      </div>
    </div>
    <div class="data_box">
      <el-table
          ref="multipleTable"
          class="table"
          :data="images"
          style="width: 100%"
          @selection-change="selectAllChange"
          @row-click="toggleSelection"
          :row-class-name="tableRowClassName"
          @sort-change="sortChange">
        <el-table-column
            type="selection"
            width="55"
        >

        </el-table-column>
        <el-table-column
            align="center"
            prop="id"
            label="id"
            width="60">
        </el-table-column>
        <el-table-column
            align="center"
            label="预览">
          <template slot-scope="scope">
            <div class="preview_container">
              <a :href="scope.row.url" 
                 :target="isVideoFile(scope.row.url) ? '_self' : '_blank'"
                 @click="handlePreviewClick($event, scope.row)">
                <img 
                  :src="isVideoFile(scope.row.url) ? getVideoSnapshot(scope.row.url) : scope.row.url" 
                  class="preview_image"
                  @error="handleImageError">
              </a>
              <!-- 视频标记 -->
              <div v-if="isVideoFile(scope.row.url)" class="video_mark">
                视频
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            width="130"
            label="分类">
          <template slot-scope="scope">
            <p>{{
                scope.row.firstCategory && scope.row.secondCategory && scope.row.thirdCategory &&
                scope.row.firstCategory.categoryName + "-" + scope.row.secondCategory.categoryName +
                "-" + scope.row.thirdCategory.categoryName
              }}</p>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="tag"
            label="图片标签"
            width="180">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="heat"
            label="热度"
            width="100">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="hotness"
            label="新热度"
            width="80">
        </el-table-column>
        <el-table-column
            align="center"
            sortable="custom"
            prop="recentHotness"
            label="最近7天热度"
            width="140">
        </el-table-column>
        <el-table-column
            align="center"
            label="大小(kb)"
            width="80">
          <template slot-scope="scope">
            <p>{{ (scope.row.size / 1024).toFixed(2) }}</p>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            prop="time"
            sortable="custom"
            width="180"
            label="上传时间">
        </el-table-column>
        <el-table-column
            align="center"
            prop="updateTime"
            sortable="custom"
            width="180"
            label="更新时间">
        </el-table-column>
        <el-table-column
            fixed="right"
            width="250"
            align="center"
            label="操作">
          <template slot-scope="scope">
            <el-button type="primary" size="medium" icon="el-icon-edit" @click="updateImage(scope.row)"></el-button>
            <el-button type="danger" size="medium" icon="el-icon-delete" @click="delImage(scope.row.id)"></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
            background
            :page-size="5"
            :current-page="pageNo"
            layout="prev, pager, next"
            :page-count="pageSum"
            @current-change="changePage">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="dialogTitle"
               @close="closeDialog"
               top="10%"
               :visible.sync="showDialog"
               :close-on-click-modal="false"
               width="80%"
               height="75vh"
               @opened="dialogOpen"
               :destroy-on-close="true"
               :fullscreen="false">
      <SearchImageUpload v-on:saveStatus="saveStatus" :images="selectImages"
                         :categoryList="categoryList" :is-update="isUpdate" :loadData="loadDialogData"/>
    </el-dialog>
  </div>
</template>

<script>
import ImageBox from "@/components/resources/ImageBox";
import SearchImageUpload from "@/components/resources/SearchImageUpload.vue";

export default {
  name: "SearchImageManage",
  components: {
    SearchImageUpload,
    ImageBox
  },
  data: function () {
    return {
      dialogTitle: "",//弹框标题
      isUpdate: false,//是否时修改图片
      selectImages: {},//当前是修改图片信息时可用
      requestNum: 0,//当前请求数量
      showLoading: false,//是否显示刷新界面
      showDialog: false,//是否显示弹框
      showDialogtoo: false,
      hasLoadImageBox: false,//是否开始加载数据
      images: [],//图片列表
      categoryList: [],//图片分类列表
      categoryId: null,
      hotOrderType: 0,//热度排序规则 0:不排序 1:升序 2:降序
      timeOrderType: 0,//上传时间排序规则 0:不排序 1:升序 2:降序
      updateTimeOrderType: 0,//更新时间排序规则 0:不排序 1:升序 2:降序
      hasTemplateDataOrderType: 0,//是否有操作数据排序 0:不排序 1:升序 2:降序
      hotnessOrder: 0,//新热度排序规则 0 不排序，1新热度升序，2新热度倒序，3最近7天热度升序，4最近7天热度倒序
      searchName: "",//图片名称搜索关键字
      pageNo: 1,//当前页面
      pageSum: 1,//总页码
      pageCount: 100,//每页显示数据量
      pageNumList: [{
        id: 0,
        label: '每页20条',
        value: 20,
      }, {
        id: 1,
        label: '每页50条',
        value: 50
      }, {
        id: 2,
        label: '每页100条',
        value: 100
      }, {
        id: 3,
        label: '每页200条',
        value: 200
      }],
      startTime: '',
      endTime: "",
      delImageIds: [],
      loadDialogData: false,
      selectcategory: []
    }
  },
  methods: {
    /**
     * 判断是否为视频文件
     * @param url 文件URL
     * @returns {boolean}
     */
    isVideoFile: function(url) {
      if (!url) return false;
      const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv', '.m4v'];
      return videoExtensions.some(ext => url.toLowerCase().includes(ext));
    },
    
    /**
     * 获取视频截图（阿里云OSS视频截帧）
     * @param videoUrl 视频URL
     * @returns {string}
     */
    getVideoSnapshot: function(videoUrl) {
      // 阿里云OSS视频截帧API，取第1秒的帧，jpg格式，80x80尺寸
      return videoUrl + '?x-oss-process=video/snapshot,t_1000,f_jpg,w_80,h_80';
    },
    
    /**
     * 处理预览点击事件
     * @param event 点击事件
     * @param row 数据行
     */
    handlePreviewClick: function(event, row) {
      if (this.isVideoFile(row.url)) {
        event.preventDefault(); // 阻止默认链接行为
        this.showVideoDialog(row.url);
      }
      // 图片文件保持默认行为（新标签页打开）
    },
    
    /**
     * 显示视频播放弹窗
     * @param videoUrl 视频URL
     */
    showVideoDialog: function(videoUrl) {
      // 方案1：弹窗播放（如果有错误可注释掉）
      try {
        this.$alert('', '视频播放', {
          dangerouslyUseHTMLString: true,
          message: `<video controls style="width: 100%; max-width: 600px;" autoplay>
                      <source src="${videoUrl}" type="video/mp4">
                      您的浏览器不支持视频播放
                    </video>`,
          showConfirmButton: false,
          closeOnClickModal: true,
          customClass: 'video-dialog',
          callback: () => {}
        }).catch(() => {});
      } catch (error) {
        // 方案2：如果弹窗有问题，改用新窗口播放
        this.openVideoInNewWindow(videoUrl);
      }
    },
    
    /**
     * 在新窗口播放视频（备用方案）
     * @param videoUrl 视频URL
     */
    openVideoInNewWindow: function(videoUrl) {
      const newWindow = window.open('', '_blank', 'width=800,height=600');
      newWindow.document.write(`
        <html>
          <head><title>视频播放</title></head>
          <body style="margin:0; background:#000; display:flex; justify-content:center; align-items:center;">
            <video controls autoplay style="max-width:100%; max-height:100%;">
              <source src="${videoUrl}" type="video/mp4">
              您的浏览器不支持视频播放
            </video>
          </body>
        </html>
      `);
    },
    
    /**
     * 处理图片加载错误
     * @param event
     */
    handleImageError: function(event) {
      // 设置默认图标（视频播放图标）
      event.target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iODAiIGhlaWdodD0iODAiIHZpZXdCb3g9IjAgMCA4MCA4MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjgwIiBoZWlnaHQ9IjgwIiBmaWxsPSIjRjVGNUY1Ii8+CjxwYXRoIGQ9Ik0zMiA1NlY0NEw0OCA1MEwzMiA1NloiIGZpbGw9IiM5OTk5OTkiLz4KPC9zdmc+';
    },
    
    /**
     * 获取当前图片列表
     * */
    getImages: function () {
      this.showLoading = true;
      this.requestNum++;
      const that = this;
      const params = new URLSearchParams()
      params.append("userId", "baozouptu")

      params.append("isPage", 1)
      params.append("pageNo", this.pageNo)
      params.append("pageCount", this.pageCount)
      params.append("isShowCategory", "1")
      if (this.categoryId == null) {
        params.append("categoryId", 0)
      } else {
        params.append("categoryId", this.categoryId)
      }
      params.append("category", "search")
      params.append("heatOrder", this.hotOrderType)
      params.append("timeOrder", this.timeOrderType)
      params.append("updateTimeOrder", this.updateTimeOrderType)
      params.append("hasTemplateDataOrder", this.hasTemplateDataOrderType)
      params.append("hotnessOrder", this.hotnessOrder)
      params.append("searchName", this.searchName)
      if (this.startTime !== undefined && this.startTime !== "") {
        params.append("startTime", this.startTime.getFullYear() + "-" + (this.startTime.getMonth() + 1) + "-" + this.startTime.getDate())
      }
      if (this.endTime !== undefined && this.endTime !== "") {
        params.append("endTime", this.endTime.getFullYear() + "-" + (this.endTime.getMonth() + 1) + "-" + this.endTime.getDate())
      }
      this.$request.post("/images/getImageList", params)
          .then(function (data) {
            that.images = data.data.records
            that.pageSum = data.data.pages
            that.requestNum--;
            that.hideLoading()
          }).catch(function (err) {
        that.requestNum--;
        that.hideLoading()
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        })
      })
    },
    /**
     * 调接判断隐藏加载界面
     * */
    hideLoading: function () {
      if (this.requestNum <= 0) {
        this.showLoading = false
      }
    },
    /**
     * 分行设置类名
     * */
    tableRowClassName: function ({row, rowIndex}) {
      // if (rowIndex % 2 === 0) {
      //     return 'warning-row';
      // } else if (rowIndex % 2 !== 0) {
      //     return 'success-row';
      // }
      return '';
    },
    /**
     * 排序规则改变
     */
    sortChange: function ({column, prop, order}) {
      //初始化排序
      this.hotOrderType = 0;
      this.timeOrderType = 0;
      this.updateTimeOrderType = 0;
      this.hasTemplateDataOrderType = 0;
      this.hotnessOrder = 0;
      switch (prop) {
        case "heat":
          this.hotOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "time":
          this.timeOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "updateTime":
          this.updateTimeOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "hasTemplateData":
          this.hasTemplateDataOrderType = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "hotness":
          this.hotnessOrder = order === "ascending" ? 1 : order === "descending" ? 2 : 0;
          break
        case "recentHotness":
          this.hotnessOrder = order === "ascending" ? 3 : order === "descending" ? 4 : 0;
          break
      }
      this.pageNo = 1;//重置页码
      this.getImages()
    },
    /**
     * 重置界面，情况所有搜索数据
     */
    reset: function () {
      // this.orderType = 0;
      this.searchName = ""
      this.pageNo = 1;
      this.categoryId = 0;
      this.getImages()
    },
    /**
     * 搜索功能
     * 清空当前分页情况
     */
    search: function () {
      this.getImages()
    },
    /**
     * 页码改变时
     * @param pageNo 改变的页码
     */
    changePage: function (pageNo) {
      this.pageNo = pageNo;
      this.getImages();
    },
    /**
     * 获取分类列表
     */
    getCategoryList: function () {
      this.requestNum++;
      this.showLoading = true;
      const that = this;
      const params = new URLSearchParams()
      params.append("isPage", 0)
      params.append("level", 1)
      this.$request.post("/imageCategory/getListByPage", params)
          .then(function (data) {
            // that.getCategory("",data.data)
            that.categoryList = data.data
            console.log(that.categoryList)
            that.requestNum--;
            that.hideLoading()
          }).catch(function (err) {
        that.requestNum--;
        that.hideLoading()
        that.$confirm("网络错误", "提示", {
          confirmButtonText: '确定',
          showClose: false,
          showCancelButton: false,
          center: true,
          type: 'error'
        })
      })
    },

    /**
     * 选项选择时
     * @param data
     */
    selectChange: function (data) {
      if (data.length > 0) {
        this.categoryId = data[data.length - 1]
      } else {
        this.categoryId = 0;
      }
    },

    /**
     * 添加一张图片
     */
    addImage: function () {
      this.dialogTitle = "添加图片信息"
      this.isUpdate = false
      this.showDialog = true
    },
    /**
     * 更新图片信息
     * */
    updateImage: function (selectImages) {
      this.dialogTitle = "添加修改素材信息"
      this.isUpdate = true
      this.showDialog = true

      selectImages.categoryIds = [selectImages.firstCategory.id, selectImages.secondCategory.id,
        selectImages.thirdCategory.id]

      selectImages.fileList = [{name: selectImages.tag, url: selectImages.url}]
      if (selectImages.materialImage !== null) {
        selectImages.materialList = [{name: selectImages.tag + "预览", url: selectImages.materialImage}]
      } else {
        selectImages.materialList = []
      }

      this.selectImages = selectImages
    },
    /**
     * 图片保存状态
     */
    saveStatus: function (flag) {
      if (flag) {
        this.getImages()
      }
      this.showDialog = false
    },

    /**
     * 弹框关闭时
     */

    closeDialog: function () {
      this.selectImages = {}
      this.loadDialogData = false;
    },
    /**
     * 删除某个图片
     * @param id 图片id
     */
    delImage: function (id) {
      this.$confirm('是否将图片移动到回收站?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: "messagebox-off-button-color",
        confirmButtonClass: "messagebox-ok-button-color"
      }).then(() => {
        this.del(id)
      }).catch(() => {
      });
    },
    /**
     * 单行点击，选中或者不选中
     */
    toggleSelection(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    /**
     * 多选回调
     * @param data 选中的对象数据
     */
    selectAllChange: function (data) {
      //清空数组
      this.delImageIds = new Array();
      //遍历选中的重新赋值
      data.forEach((item) => {
        this.delImageIds.push(item.id)
      })
    },
    /**
     * 发出删除一个图片请求
     * @param id
     */
    del: function (id) {
      this.requestNum++;
      const params = {
        "ids": [id],
        "state": 1,
      }
      this.requestDelImages(params)
    },
    /**
     * 删除多个图片
     */
    delImages: function () {
      this.$confirm('此操作将选中的文件批量移动到回收站, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        cancelButtonClass: "messagebox-off-button-color",
        confirmButtonClass: "messagebox-ok-button-color"
      }).then(() => {
        this.delAll()
      }).catch(() => {
      });
    },
    /**
     * 删除选中的数据
     */
    delAll: function () {
      if (this.delImageIds === undefined || this.delImageIds.length === 0) {
        return
      }
      const params = {
        "ids": this.delImageIds,
        "state": 1,
      }
      this.requestDelImages(params)
    },
    requestDelImages: function (params) {
      this.showLoading = true;
      const that = this;
      this.$request.post("/images/delImage", params, {
        // json格式
        headers: {
          "Content-Type": "application/json"
        },
      }).then(function (data) {
        that.showLoading = false;
        if (data.status === 200) {
          that.$message.success("批量删除成功");
          that.getImages()
        } else {
          that.showError(data.data)
        }
      }).catch(function (err) {
        that.showLoading = false;
        that.hideLoading()
        that.showError("网络错误")
      })
    },
    showError: function (msg) {
      this.$confirm(msg, "提示", {
        confirmButtonText: '确定',
        showClose: false,
        showCancelButton: false,
        center: true,
        type: 'error'
      })
    },
    dialogOpen: function () {
      this.loadDialogData = true;
    },
    open: function () {
      this.showDialogtoo = true
    },
    postFrom: function (data) {
      console.log(data)
    },
    getCategory: function (name, categorys) {
      categorys.forEach(item => {
        let category = {}
        category.id = item.id
        category.categoryName = name + item.categoryName
        this.categoryList.push(category)
        if (item.childList !== null && item.childList !== undefined && item.childList.length > 0) {
          this.getCategory(category.categoryName + "/", item.childList)
        }
      })
    },
    // selectcategoryId:function (categoryList){
    //
    //   for (let i =0 ; i<categoryList.length;i++){
    //     if(categoryList[i].childList ===null)
    //       this.selectcategory.add(this.categoryList[i].id())
    //     return this.categoryList[i].id();
    //     return;
    //   }
    //   return
    // }
  },
  mounted: function () {
    this.$bus.$emit("setMenuActiveIndex", "1-1-2");
    // 快捷搜索外链：?searchName=关键词 自动填入并搜索
    var q = this.$route.query && this.$route.query.searchName;
    if (q) {
      this.searchName = String(q);
      this.pageNo = 1;
    }
    this.getImages()

    this.getCategoryList()
    console.log(this.getCategoryList.categoryId)
  },

}
</script>

<style scoped>
.image_box {
  width: 100%;
  min-height: 100%;
  background: white;
  border-radius: 5px;
  padding: 10px 20px;
}

.box_operation {
  width: 100%;
  padding: 10px 0;
}

.input_box {
  display: inline-block;
  width: 200px;
  margin: 0 10px;
  margin-top: 10px;
}

.input_box /deep/ .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 90%;
  margin: 0 auto;
}

.btn_box {
  height: 40px;
  margin-top: 10px;
  margin: 10px;
  vertical-align: top;
  display: inline-block;
}

.input_box_select {
  width: 150px;
}

.data_box {
  width: 100%;

}

.preview_container {
  position: relative;
  display: inline-block;
}

.preview_image {
  width: 80px;
  height: 80px;
}

.video_mark {
  position: absolute;
  top: 2px;
  right: 2px;
  padding: 4px 6px;
  background: rgba(255, 200, 0, 0.9);
  color: black;
  font-size: 12px;
  font-weight: bold;
  border-radius: 4px;
  z-index: 10;
  line-height: 1;
}

.data_box /deep/ .el-table .warning-row {
  background: oldlace;
}

.data_box /deep/ .el-table .success-row {
  background: #f0f9eb;
}

.page {
  width: 100%;
  margin: 20px 0;
  text-align: center;
}

/* 视频播放弹窗样式 */
/deep/ .video-dialog {
  max-width: 80%;
}

/deep/ .video-dialog .el-message-box__content {
  text-align: center;
}

/deep/ .video-dialog .el-message-box__message {
  margin: 0;
}

.table {
  /*position: fixed;*/
  height: 100%;
}

</style>
